"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hooks = require("../../../hooks");

var _reactHooks = require("@trycourier/react-hooks");

var _styled = require("../styled");

var _useHover = _interopRequireDefault(require("../../../hooks/use-hover"));

var _Close = _interopRequireDefault(require("./Close"));

var _MarkRead = _interopRequireWildcard(require("./MarkRead"));

var _MarkUnread = _interopRequireDefault(require("./MarkUnread"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _lib = require("../../../lib");

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var OptionsSvg = function OptionsSvg(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2.5",
    cy: "18.5",
    r: "2.5",
    fill: "#73819B"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2.5",
    cy: "10.5",
    r: "2.5",
    fill: "#73819B"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "2.5",
    cy: "2.5",
    r: "2.5",
    fill: "#73819B"
  }));
};

OptionsSvg.defaultProps = {
  width: "5",
  height: "21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var MobileActionsMenuButton = _styledComponents["default"].button.withConfig({
  displayName: "actions__MobileActionsMenuButton",
  componentId: "sc-1atq9qi-0"
})(function (_ref) {
  var _theme$message, _theme$message$action;

  var theme = _ref.theme;
  return (0, _deepExtend["default"])({
    marginTop: "50px",
    padding: "0 12px",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    svg: {
      transform: "rotate(90deg)"
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message = theme.message) === null || _theme$message === void 0 ? void 0 : (_theme$message$action = _theme$message.actionMenu) === null || _theme$message$action === void 0 ? void 0 : _theme$message$action.button);
});

var MobileActions = _styledComponents["default"].div.withConfig({
  displayName: "actions__MobileActions",
  componentId: "sc-1atq9qi-1"
})(function (_ref2) {
  var _theme$message2, _theme$message2$actio;

  var theme = _ref2.theme;
  return (0, _deepExtend["default"])({
    marginTop: "42px",
    width: "150px",
    display: "flex",
    background: "white",
    flexDirection: "column",
    borderRadius: "6px",
    zIndex: 1,
    border: "1px solid #d5d1d1",
    boxShadow: "0px 8px 24px rgba(28,39,58,0.3)",
    button: {
      cursor: "pointer",
      "&:first-child": {
        borderBottom: "1px solid #d5d1d1"
      },
      border: "none",
      width: "100%",
      padding: "10px 0",
      background: "transparent"
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message2 = theme.message) === null || _theme$message2 === void 0 ? void 0 : (_theme$message2$actio = _theme$message2.actionMenu) === null || _theme$message2$actio === void 0 ? void 0 : _theme$message2$actio.dropdown);
}); // eslint-disable-next-line @typescript-eslint/no-unused-vars


var Styled = _styledComponents["default"].div.withConfig({
  displayName: "actions__Styled",
  componentId: "sc-1atq9qi-2"
})(function (_props) {
  return {
    display: "flex",
    height: 24,
    alignItems: "center",
    position: "absolute",
    right: 12,
    ".close": {
      marginRight: -6,
      marginLeft: 6,
      marginTop: -3
    },
    "> div": {
      opacity: 0,
      top: 4,
      right: 0,
      position: "absolute",
      visibility: "hidden",
      transition: "opacity 200ms ease-in-out",
      "&:not(.hidden)": {
        opacity: 1,
        visibility: "visible",
        textAlign: "right"
      }
    },
    ".message-actions": {
      display: "flex",
      alignItems: "center",
      marginTop: 2
    },
    "&.hasBody": {
      top: 12
    },
    "&:not(.hasBody)": {
      top: 8
    }
  };
});

var MessageActions = function MessageActions(_ref3) {
  var _labels$markAsRead, _labels$markAsRead2, _labels$archiveMessag;

  var created = _ref3.created,
      formatDate = _ref3.formatDate,
      hasBody = _ref3.hasBody,
      isMessageActive = _ref3.isMessageActive,
      isMobile = _ref3.isMobile,
      labels = _ref3.labels,
      messageId = _ref3.messageId,
      read = _ref3.read,
      archived = _ref3.archived,
      setAreActionsHovered = _ref3.setAreActionsHovered;
  var actionsHoverRef = (0, _react.useRef)(null);
  var mobileActionsRef = (0, _react.useRef)(null);
  var areActionsHovered = (0, _useHover["default"])(actionsHoverRef);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showMobileActions = _useState2[0],
      setShowMobileActions = _useState2[1];

  (0, _react.useEffect)(function () {
    setAreActionsHovered(areActionsHovered);
  }, [areActionsHovered]);

  var _useInbox = (0, _reactHooks.useInbox)(),
      markMessageArchived = _useInbox.markMessageArchived,
      markMessageRead = _useInbox.markMessageRead,
      markMessageUnread = _useInbox.markMessageUnread;

  var handleEvent = function handleEvent(eventName) {
    return function (event) {
      event === null || event === void 0 ? void 0 : event.preventDefault();

      if (!messageId) {
        return;
      }

      switch (eventName) {
        case "archive":
          {
            markMessageArchived(messageId);
            break;
          }

        case "read":
          {
            markMessageRead(messageId);
            break;
          }

        case "unread":
          {
            markMessageUnread(messageId);
            break;
          }
      }

      setShowMobileActions(false);
    };
  };

  var formattedTime = formatDate ? formatDate(archived ? archived : created) : (0, _lib.getTimeAgoShort)(archived ? archived : created);
  var readableTimeAgo = formatDate ? formattedTime : (0, _lib.getTimeAgo)(archived ? archived : created);
  var markAsReadLabel = (_labels$markAsRead = labels === null || labels === void 0 ? void 0 : labels.markAsRead) !== null && _labels$markAsRead !== void 0 ? _labels$markAsRead : "Mark as Read";
  var markUnreadLabel = (_labels$markAsRead2 = labels === null || labels === void 0 ? void 0 : labels.markAsRead) !== null && _labels$markAsRead2 !== void 0 ? _labels$markAsRead2 : "Mark Unread";
  var archiveLabel = (_labels$archiveMessag = labels === null || labels === void 0 ? void 0 : labels.archiveMessage) !== null && _labels$archiveMessag !== void 0 ? _labels$archiveMessag : "Archive Message";
  (0, _hooks.useClickOutside)(mobileActionsRef, function (event) {
    var target = event.target;

    if (target !== null && target !== void 0 && target.closest(".action-menu[data-message-id=\"".concat(messageId, "\"]"))) {
      return;
    }

    setShowMobileActions(false);
  });
  return /*#__PURE__*/_react["default"].createElement(Styled, {
    ref: actionsHoverRef,
    className: (0, _classnames["default"])({
      hasBody: hasBody
    })
  }, !archived && isMobile && /*#__PURE__*/_react["default"].createElement(MobileActionsMenuButton, {
    className: "action-menu",
    "data-message-id": messageId,
    onClick: function onClick() {
      setShowMobileActions(!showMobileActions);
    }
  }, /*#__PURE__*/_react["default"].createElement(OptionsSvg, null)), showMobileActions && /*#__PURE__*/_react["default"].createElement(MobileActions, {
    ref: mobileActionsRef
  }, read ? /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleEvent("unread")
  }, markUnreadLabel) : /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleEvent("read")
  }, markAsReadLabel), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleEvent("archive")
  }, archiveLabel)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      hidden: !isMobile && !isMessageActive
    })
  }, /*#__PURE__*/_react["default"].createElement(_styled.TimeAgo, {
    tabIndex: 0,
    title: created,
    "aria-label": "created ".concat(readableTimeAgo),
    style: {
      textAlign: "right"
    }
  }, archived ? "Archived: ".concat(formattedTime) : formattedTime), !archived && !isMobile && /*#__PURE__*/_react["default"].createElement("div", {
    className: "message-actions"
  }, !read && /*#__PURE__*/_react["default"].createElement(_MarkRead["default"], {
    label: markAsReadLabel,
    onClick: handleEvent("read")
  }), read && /*#__PURE__*/_react["default"].createElement(_MarkUnread["default"], {
    label: markUnreadLabel,
    onClick: handleEvent("unread")
  }), /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    size: "small",
    title: archiveLabel,
    onClick: handleEvent("archive"),
    tooltip: archiveLabel
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      hidden: isMobile || isMessageActive
    })
  }, /*#__PURE__*/_react["default"].createElement(_styled.TimeAgo, null, formattedTime), read && /*#__PURE__*/_react["default"].createElement(_MarkRead.Checkmark, {
    fill: "rgba(86, 96, 116, 0.3)",
    style: {
      marginRight: -6,
      marginLeft: -3
    }
  })));
};

var _default = MessageActions;
exports["default"] = _default;